
export default {
  name: 'AppButton',
};
